import { FC } from 'react'
import styled from 'styled-components'
import { Button as AntButton } from 'antd'
import { ButtonProps } from 'antd/lib/button/button'

export const Button: FC<ButtonProps> = styled(AntButton)`
  font-family: 'KONE Information';
  text-transform: uppercase;
`
